module.exports = __webpack_public_path__ + "static/media/partnership_2.d692ebbb.png";